module.exports = __webpack_public_path__ + "img/left-arrow.eddd4f01.svg";